
export const openMenu = () =>{
    return {
        type:"OPEN_MENU",
        show:true
    }
}
export const closeMenu = () => {
    return {
        type:"CLOSE_MENU",
        show:false
    }
}